module.exports = __webpack_public_path__ + "img/dining.c9e29bda.svg";